import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = {
    id: String,
  }

  connect() {
    if (!this.idValue) return;

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });

    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtm.js?id=${this.idValue}`;
    document.head.appendChild(script);
  }
}
